import { z } from 'zod';
import { c } from '../../contract';

export const referralCodeRouter = c.router(
  {
    getMyCode: {
      summary: "Get or create the authenticated user's own referral code (migrated from Jupiter, DEV-4476)",
      method: 'GET',
      path: '/get-my-code',
      responses: {
        200: z.object({ code: z.string() }),
      },
    },
    getReferralCode: {
      summary:
        'Get the referral code of the person who referred the authenticated user, if any (migrated from Jupiter, DEV-4476)',
      method: 'GET',
      path: '/get-referral-code',
      responses: {
        200: z.object({ code: z.string().nullable() }),
      },
    },
    findUserByCode: {
      summary: 'Resolve the userId that owns a referral code (migrated from Jupiter v2, DEV-4476)',
      method: 'GET',
      path: '/find-user-by-code',
      query: z.object({ code: z.string() }),
      responses: {
        200: z.object({ userId: z.string().nullable() }),
      },
    },
  },
  {
    pathPrefix: '/referral-code',
  },
);
